var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-tooltip card p-2"},[_c('span',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }